import Cookies from 'react-cookies'
import CryptoJS from 'crypto-js';
import axios from "axios";

//获取参数
let getQuery = (variable) => {
    let str = '';
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        if(pair[0] == variable){
            str = pair[1]
        }
    }
    if(str == '' && variable == 'web_qtstr'){
        str = Cookies.load('web_qtstr') == undefined ? '' : Cookies.load('web_qtstr')
    }
    return str;
}

//获取登录cookies
let getToken = () => {
    let webQtstr = Cookies.load('web_qtstr');
    if (webQtstr && webQtstr != undefined) {
      return decodeURIComponent(webQtstr);
    }
    webQtstr = getQuery("web_qtstr");
    if (webQtstr && webQtstr != undefined) {
      return decodeURIComponent(webQtstr);
    } 
    return '';
}

let exitLogin = () => {
  Cookies.save("web_qtstr", null, {path:"/",maxAge:0});
  Cookies.save("qtstr", null, {path:"/",maxAge:0});
  Cookies.remove("web_qtstr");
  Cookies.remove("qtstr");
  window.localStorage.removeItem("key");
}

//是否为手机
let isMobile = () => {
  if (getQuery('source') == 'h5') {
    return true;
  }
  //不支持PC版
  if ( process.env.REACT_APP_SUPPORT_PC == '0') {
    return true;
  }
  if (/Mobi|Android|iPhone|HarmonyOS|DxwApp/i.test(navigator.userAgent)) {
    return true;
  }
  //屏幕宽度
  if (window.screen.width < 700) {
    return true;
  }
  //网页可见部分宽度
  if (window.innerWidth < 700) {
    return true;
  }
  return false;
}

//是否为鸿蒙
let isHongmeng = () => {
  if (/HarmonyOS|OpenHarmony/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

//是否APP打开
let isApp = () => {
  if ('WebViewJavascriptBridge' in window) {
    return true;
  }
  return false;
}

let bigNumberTransform = (value) => {
  const newValue = ['', '', '']
  let fr = 1000
  let num = 3
  let text1 = ''
  let fm = 1
  while (value / fr >= 1) {
    fr *= 10
    num += 1
    // console.log('数字', value / fr, 'num:', num)
  }
  if (num <= 4) { // 千
    newValue[0] = parseInt(value / 1000) + ''
    newValue[1] = '千'
  } else if (num <= 8) { // 万
    text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
    // tslint:disable-next-line:no-shadowed-variable
    fm = text1 === '万' ? 10000 : 10000000
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(2) + ''
    }
    newValue[1] = text1
  } else if (num <= 16) { // 亿
    text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
    text1 = (num - 8) / 4 > 1 ? '万亿' : text1
    text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
    // tslint:disable-next-line:no-shadowed-variable
    fm = 1
    if (text1 === '亿') {
      fm = 100000000
    } else if (text1 === '千亿') {
      fm = 100000000000
    } else if (text1 === '万亿') {
      fm = 1000000000000
    } else if (text1 === '千万亿') {
      fm = 1000000000000000
    }
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(2) + ''
    }
    newValue[1] = text1
  }
  if (value < 1000) {
    newValue[0] = value + ''
    newValue[1] = ''
  }
  return newValue.join('')
}

//自适应设置body高度
let getAutoDocumentHeight = (otherHeight = 0) => {
  //浏览器可视区域高度
  let windowHeight = window.innerHeight;
  //头部导航高度50px
  let headerHeight = 50;
  //头部空隙间距20px
  let headerMargin = 20;
  //底部空隙间距 50px
  let footerMargin = 50;
  let height = windowHeight - headerHeight - headerMargin - footerMargin - otherHeight - 50;
  return height;
}

//数据签名
let getSignStr = (param) => {
  //1.排序
  var sortedObj = {};
  Object.keys(param).sort().forEach((key) => {  
    sortedObj[key] = param[key];  
  });
  //2.链接字符串
  var paramStr = Object.entries(sortedObj).map(([key, value]) => `${key}=${value}`).join('');
  return paramStr;
}

let getSign = (paramStr) => {
  //3.拼接签名密钥
  var requestStr = paramStr +  process.env.REACT_APP_SECRET;
  //4.md5加密
  var dxwsign = CryptoJS.MD5(requestStr).toString();
  return dxwsign;
}

let requestErr = (code, msg) => {
  //Toast.show({icon: "fail", content: msg});
}

//GET请求短线王接口
let httpGet = (path, param, callback, errback=requestErr) => {
  param['source'] = "cangwei";
  let timestamp = Date.parse(new Date()) / 1000;
  let paramNew = Object.assign({}, param);
  paramNew.timestamp  = timestamp;
  if (process.env.REACT_APP_KEY && process.env.REACT_APP_SECRET) { 
    paramNew.dxwappid = process.env.REACT_APP_KEY;
    let paramStr = getSignStr(paramNew)
    paramNew.dxwsign = getSign(paramStr);
  }
  let queryStr = Object.entries(paramNew).map(([key, value]) => `${key}=${value}`).join('&');
  let apiHost = getApiHost();
  axios.get(apiHost + path + '?' + queryStr ).then(function(response){
    if (response.data.code == 10000) {
      callback(response.data.data);
    } else {
      errback(response.data.code, response.data.msg);
    }
  }).catch(function(ex) {
    console.info(ex);
  });
}

//POST请求短线王接口
let httpPost = (path, param, query, callback, errback=requestErr) => {
  let postParam = {};
  for(var [key,val] of param) {
     postParam[key] = val;
  }
  let paramNew = Object.assign({}, query);
  if (process.env.REACT_APP_KEY && process.env.REACT_APP_SECRET && path != '/img/uploadtoaliyun') { 
    paramNew.dxwappid = process.env.REACT_APP_KEY;
    paramNew.timestamp = Date.parse(new Date()) / 1000;
    let getParamStr = getSignStr(paramNew);
    let postParamStr = getSignStr(postParam);
    paramNew.dxwsign = getSign(postParamStr + getParamStr);
  }
  let queryStr = Object.entries(paramNew).map(([key, value]) => `${key}=${value}`).join('&');
  let apiHost = getApiHost();
  axios.post(apiHost + path + '?' + queryStr, param).then(function(response){
    if (response.data.code == 10000 || response.data.code == 1000) {
      callback(response.data.data);
    } else {
      errback(response.data.code, response.data);
    }    
  }).catch(function(ex){
    console.info(ex)
  })
}

let getTextClassName = (index) => {
  if (index == 0) {
    return 'first-num';
  }
  if (index == 1) {
    return 'second-num';
  }
  if (index == 2) {
    return 'third-num';
  }
  return 'normal-num';
}

let getBaseHost = () => {
  const host = window.location.host;
  const protocol = window.location.protocol;
  const baseHost = protocol + "//" + host;
  return baseHost;
}

let getApiHost = () => {
  const baseHost = getBaseHost();
  const apiHost = baseHost + '/api';
  return apiHost;
}

export default {
    "getQuery" : getQuery,
    "getToken" : getToken,
    "isMobile": isMobile,
    "bigNumberTransform": bigNumberTransform,
    "exitLogin": exitLogin,
    "getAutoDocumentHeight": getAutoDocumentHeight,
    "isApp" : isApp,
    "isHongmeng": isHongmeng,
    "httpGet": httpGet,
    "httpPost": httpPost,
    "getTextClassName": getTextClassName,
    "getBaseHost": getBaseHost
}